import { render, staticRenderFns } from "./TableModal.vue?vue&type=template&id=4452cee0&"
import script from "./TableModal.vue?vue&type=script&lang=ts&"
export * from "./TableModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports